<template>
  <v-dialog v-model="internalValue" max-width="800px" persistent scrollable>
    <v-card class="rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between border-light-bottom">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">{{ isEditing ? 'mdi-pencil-outline' : 'mdi-plus-circle-outline' }}</v-icon>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            {{ isEditing ? 'Editar Tema de Capacitación' : 'Nuevo Tema de Capacitación' }}
          </span>
        </div>
        <v-btn icon small @click="close">
          <v-icon color="grey darken-2">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-5 px-6">
        <v-row dense>
          <v-col cols="12" md="8">
            <s-text v-model="form.TtpTitle" label="Título del Tema *" :rules="[v => !!v || 'El tema es requerido']" />
          </v-col>
          <!-- <v-col cols="12" md="4">
            <s-select-definition :def="1067" v-model="form.TypeInstruction" label="Tipo de Instrucción *" />
          </v-col> -->

          <!-- <v-col cols="12" md="6">
            <s-select-area v-model="form.AreID" :text="form.AreName" label="Área Responsable" />
          </v-col> -->
          <v-col cols="12" sm="6" md="2">
            <s-text v-model.number="form.TtpDurationMinutes" label="Duración (minutos)" number />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <s-text v-model.number="form.TtpValidityMonths" label="Frecuencia (meses)" number />
          </v-col>

          <v-col cols="12">
            <s-textarea v-model="form.TtpDescription" label="Descripción / Objetivos" />
          </v-col>

          <v-col cols="12" sm="6" class="mt-2">
            <v-card class="pa-3 border-light rounded-lg" outlined elevation="0">
              <v-switch
                v-model="form.TtpRequiresRenewal"
                :true-value="1"
                :false-value="0"
                color="primary"
                inset
                dense
                hide-details
                class="ma-0"
              >
                <template v-slot:label>
                  <span class="font-weight-bold grey--text text--darken-3">Requiere Renovación Periódica</span>
                </template>
              </v-switch>
              <div class="text-caption grey--text text--darken-1 mt-1">
                Indica si el colaborador debe volver a cursar la capacitación al caducar su vigencia.
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" class="mt-2">
            <v-card class="pa-3 border-light rounded-lg" outlined elevation="0">
              <v-switch
                v-model="form.TtpRequiresCertificate"
                :true-value="1"
                :false-value="0"
                color="primary"
                inset
                dense
                hide-details
                class="ma-0"
              >
                <template v-slot:label>
                  <span class="font-weight-bold grey--text text--darken-3">Emisión de Certificado</span>
                </template>
              </v-switch>
              <div class="text-caption grey--text text--darken-1 mt-1">
                Genera u otorga constancia/certificado formal de aprobación al cumplir asistencia.
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-3 px-6 justify-end bg-white">
        <v-btn text class="rounded-lg text-none font-weight-bold grey--text text--darken-3 px-4" @click="close">
          Cancelar
        </v-btn>
        <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-6 white--text" elevation="0" :loading="saving" @click="save">
          <v-icon left small>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import SSelectArea from "@/components/Utils/SSelectArea.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import TrainingTopicService from "@/services/Management/TrainingTopicService";

export default {
  name: "TrainingTopicFormModal",
  components: {
    SText,
    SSelectArea,
    SSelectDefinition,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        TtpID: 0,
        TtpTitle: "",
        TtpDescription: "",
        AreID: null,
        AreName: "",
        TypeInstruction: 2, // Capacitación por defecto
        TtpDurationMinutes: 60,
        TtpValidityMonths: 12,
        TtpRequiresRenewal: 1,
        TtpRequiresCertificate: 1,
        SecStatus: 1,
      },
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isEditing() {
      return this.form.TtpID > 0;
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editItem && this.editItem.TtpID) {
          this.form = Object.assign({}, this.editItem);
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        TtpID: 0,
        TtpTitle: "",
        TtpDescription: "",
        AreID: null,
        AreName: "",
        TypeInstruction: 2,
        TtpDurationMinutes: 60,
        TtpValidityMonths: 12,
        TtpRequiresRenewal: 1,
        TtpRequiresCertificate: 1,
        SecStatus: 1,
      };
    },
    close() {
      this.internalValue = false;
    },
    save() {
      if (!this.form.TtpTitle || !this.form.TtpTitle.trim()) {
        this.$fun.alert("El título del tema es obligatorio.", "warning");
        return;
      }
      if (!this.form.TypeInstruction) {
        this.$fun.alert("Seleccione el tipo de instrucción.", "warning");
        return;
      }

      this.$fun.alert("¿Está seguro de guardar la información del tema?", "question").then((r) => {
        if (r && r.value) {
          this.saving = true;
          const reqId = this.$fun.getUserID();
          TrainingTopicService.save(this.form, reqId)
            .then(() => {
              this.$fun.alert("Tema guardado correctamente.", "success");
              this.$emit("saved");
              this.close();
            })
            .catch((err) => {
              this.$fun.alert(err?.response?.data?.Message || "Error al guardar el tema.", "error");
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
  },
};
</script>
